export class Payment
{
  smartcard: string;
  basketid: string;
  firstname: string;
  lastname: string;
  duedate: string;
  currentbouquet: string
  merchantReference: string;
  amount: string;
  currency: string;  
}



// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/paymentmodel.ts